import { Action } from '@ngrx/store';
import { IsCallCenterActions, IsCallCenterActionTypes } from '@store/actions/is-call-center.actions';

export const initialState = false;

export function isCallCenterReducer(state: boolean = initialState, action: Action): boolean {
    const typedAction = action as IsCallCenterActions; 
    switch (typedAction.type) {
        case IsCallCenterActionTypes.Set:
            return true;
        case IsCallCenterActionTypes.Reset:
            return false;
        default:
            return state;
    }
}
